import DocumentResourceModel from '../../generated/types/model/resource/DocumentResourceModel';

export default class DocumentResourceViewModel extends DocumentResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
